<template>
  <div class="outro-section">
    <div class="content-holder">
      <div class="content">
        <span class="title">Colofon en verantwoording</span>
        <p class="text">
          Alle cijfers in dit verhaal zijn naar benadering. We vroegen Rockstar om de cijfers te bevestigen. Dat willen ze niet, maar het bedrijf "kan zich vinden in onze telling". De hoeveelheid werknemers is een optelsom gemaakt op basis van de aftiteling van de game. Het kan zijn dat sommige namen daardoor dubbelen.
        </p>
        <colofon-social />
      </div>
      <div class="content">
        <!-- <span class="title">&nbsp;</span> -->
        <p class="text">
          <strong>Tekst, research en telling:</strong><br>
          Stephan Vegelien<br><br>
          <strong>Beeld:</strong><br>
          Mike van Boxtel, Lars Boogaard, Ferhat Gökdemir<br><br>
          <strong>Code:</strong><br>
          Drewes Bos<br><br>
          <strong>Eindredactie:</strong><br>
          Roel van Niekerk
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ColofonSocial from './ColofonSocial';

export default {
  components: {
    ColofonSocial,
  },
};
</script>
<style lang="scss" scoped>
  .outro-section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    min-width: 100vw;
    height: 100%;
    position: absolute;
    z-index: 10;
    top: 0;
  }

  .content-holder {
    display: flex;
    flex-flow: row nowrap;
    width: auto;
    margin: 50px 0;
    top: 0;
    left: 0;
  }

  .content {
    display: flex;
    flex-flow: column nowrap;
    width: 80vw;
    max-width: 400px;
    margin-right: 50px;
    align-items: flex-start;
    justify-content: flex-start;
    color: #000000;
    overflow: auto;
  }

  .title {
    display: block;
    width: 100%;
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
  }

  .text {
    display: block;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OutroSection.vue